module.exports = __webpack_public_path__ + "img/9788932915920.214f7817.jpg";